import { Card, css } from '@mui/material';

type Params = {
    text: string;
};

const styles = css({
    //background: '#ccc',
    padding: 7,
    //borderRadius: 5
});

export const OverlayFeatureLayerMap = ({text}: Params) => {
    return <Card css={styles}>{text}</Card>;
};